import { queryOptions, useQuery } from "@tanstack/react-query";
import { restGet } from "@/lib/supabaseRest";

export type PromoSlide = {
  image_desktop?: string;
  image_mobile?: string;
  alt?: string;
  href?: string;
  open_in_new_tab?: boolean;
  visible?: boolean;
};

export type PromoCarouselContent = {
  layout?: {
    autoplay?: boolean;
    interval_ms?: number;
    show_arrows?: boolean;
    show_dots?: boolean;
    full_width?: boolean;
    aspect_desktop?: string; // e.g. "3 / 1"
    aspect_mobile?: string;  // e.g. "4 / 3"
  };
  slides: PromoSlide[];
};

export const PROMO_CAROUSEL_SECTION_KEY = "promo_carousel";

/** CMS promo banner carousel (page_content: section_key='promo_carousel'). */
export function promoCarouselQueryOptions(slug: string) {
  return queryOptions({
    queryKey: ["promo-carousel", slug],
    queryFn: async (): Promise<PromoCarouselContent | null> => {
      const rows = await restGet<{ content: unknown; is_published: boolean }[]>(
        `page_content?select=content,is_published&page_slug=eq.${encodeURIComponent(slug)}&section_key=eq.${PROMO_CAROUSEL_SECTION_KEY}&limit=1`,
      );
      const row = rows?.[0];
      if (!row || row.is_published === false) return null;
      const c = row.content as any;
      if (!c || !Array.isArray(c.slides)) return null;
      return c as PromoCarouselContent;
    },
    staleTime: 60_000,
    refetchOnWindowFocus: false,
    retry: 1,
  });
}

export function usePromoCarousel(slug = "home") {
  return useQuery(promoCarouselQueryOptions(slug));
}